import { createFileRoute } from "@tanstack/react-router";
import ContratoEditor from "@/pages/admin/ContratoEditor";
import { pageHead } from "@/lib/seo";

function Editar() {
  const { id } = Route.useParams();
  return <ContratoEditor contratoId={id} />;
}

export const Route = createFileRoute("/admin/contratos/$id/editar")({
  head: () => pageHead({ title: "Editar contrato | Painel", path: "/admin/contratos", noindex: true }),
  component: Editar,
});
